angular.module('unergie.main', [
    'angularMoment',
    'wu.masonry',
    'ng',
    'ngCookies',
    'ui.bootstrap',
    'ui.router',
    'permission',
    'templates',
    'ngResource',
    'mgcrea.jquery',
    'mgcrea.bootstrap.affix',
    'smoothScroll',
    'ui.mask',
    'ngAnimate',
    'focus-if',
    'ngTable',
    'ngTableToCsv',
    'angular-clipboard',
    'ckeditor',
    'ngFileUpload',
    'jsonFormatter',
    'rzModule',
    'mm.iban',
    'btford.socket-io',
    'ngSanitize',
    'angular-web-notification',
    'angularFileUpload',
    'btorfs.multiselect',
])
